import { ReportActionTypes, All } from '../actions/report.actions';
import { Report, RequestStatus } from '@app/shared';

// define State interface
export interface State {
  // is a user authenticated?
  selectedReport: Report | null;
  // if authenticated, there should be a user object
  reports: Report[] | null;
  errorStatus: RequestStatus | null;
  successStatus: RequestStatus | null;
  isEditing: boolean | null;
  actionType: string | null;
}

// define initial state
export const initialState: State = {

  selectedReport: null,
  reports: null,
  errorStatus: null,
  successStatus: null,
  isEditing:false,
  actionType:null,
};

export function reducer(state = initialState, action: All): State {
  switch (action.type) {
    case ReportActionTypes.GET_PAGE_REPORTS_SUCCESS:
    case ReportActionTypes.GET_JOB_REPORTS_SUCCESS: {
      return {
        ...state,
        selectedReport: null,
        reports: action.payload.reports,
        errorStatus:null,
        actionType:action.type,
      };
    }

    case ReportActionTypes.GET_PAGE_REPORTS_FAILURE:
    case ReportActionTypes.GET_JOB_REPORTS_FAILURE: {
      return {
        ...state,
        errorStatus: action.payload.error.statusText,
        actionType:action.type,
      };
    }
    default: {
      return {
        ...state,
        actionType:null,
      };
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/reducers/report.reducer.ts